import { useContext } from "react";
import { AuthContext } from "../../../Authorization/AuthContext";
import { MarkdownTooltip } from "../../../Common/Tooltip";
import { TooltipContainer } from "../__styles__/";

export const PropertyOverviewTooltip = ({
  tooltipMarkdown,
  isPublicOnly = true,
}: {
  tooltipMarkdown?: Maybe<string>;
  isPublicOnly?: boolean;
}) => {
  const { isPublic } = useContext(AuthContext);
  if (!tooltipMarkdown || (!isPublic && isPublicOnly)) {
    return <></>;
  }

  return (
    <TooltipContainer data-testid="tooltip">
      <MarkdownTooltip tooltipText={tooltipMarkdown} place="right" />
    </TooltipContainer>
  );
};
